// import 'slick-carousel'

export default (() => {
  class TransitionMobile {
    constructor() {
      this.nav = $('.entrytype-course-v2 .course-content__nav')
      this.root = $('.entrytype-course-v2 .mobile-container')
      this.panels = $('.track', this.root).children()

      this.leftDiv = $('.mobile-container__left', this.root)
      this.rightDiv = $('.mobile-container__right', this.root)

      // Copy all the panels into the mobile container
      const hr = $('.mobile-container__back.top', this.rightDiv)
      hr.after(this.panels.detach())

      // Hide all to begin with
      this.panels.hide();
    }

    backToNav() {
      const height = this.leftDiv.outerHeight(true)
      this.root.css({
        'transform': 'translateX(0%)',
        'height': height+'px'
      })

      // also need to scroll back to nav if we were using the bottom back button
      const navTop = this.nav.offset().top
      const navBottom = navTop + this.nav.height()
      if(window.scrollY > navBottom) {
        window.scrollTo({top: navTop - 200, behavior: 'smooth'});
      }
    }

    setPanelIndex(index) {
      this.panels.hide();
      this.panels.eq(index).show()
      this.updateHeight()
    }

    updateHeight() {
      const height = this.rightDiv.outerHeight(true)
      this.root.css({
        'transform': 'translateX(-50%)',
        'height': height+'px'
      })
    }
  }

  class TransitionDesktop {

    constructor() {
      this.root = $('.entrytype-course-v2 .course-content__panels')
      this.track = $('.track', this.root)
      this.panels = this.track.children()
      this.currentIndex = -1

      this.track.css({'display':'flex'})
      this.updateLayout();
    }

    updateLayout() {
      const rootW = this.root.width()
      const trackW = rootW * this.panels.length
      this.track.css('width', trackW + 'px' )
    }

    updateHeight(immediate=false) {
      const panel = this.panels.eq(this.currentIndex)
      const panelHeight = panel.outerHeight()
      this.root.css({
        height: panelHeight + 'px',
        transitionProperty: immediate ? 'none' : null
      }) // height should already have a CSS transition applied
    }

    setPanelIndex(index, scroll = true) {
      if(this.currentIndex === index) return;
      this.currentIndex = index;

      // UPDATE NAV STATE
      $('.course-content__nav li').removeClass('active')

      const currNavItem = $('.course-content__nav li').eq(this.currentIndex)
      currNavItem.addClass('active')

      // UPDATE SLIDE
      this.updateHeight()
      const percent = (this.currentIndex > 0 ? this.currentIndex / this.panels.length : 0) * 100
      this.track.css('transform', `translateX(-${percent}%)`) // transform should already have a CSS transition applied

      // SCROLL TO TOP (if we aren't already close)
      if(scroll) {
        const pageTop = this.root.offset().top
        const scrollY = window.scrollY
        if(scrollY - pageTop > 200) {
          window.scrollTo({top: pageTop - 100, behavior: 'smooth'});
        }
      }
    }
  }

  $(function() {
    if(!$('.entrytype-course-v2').length) {
      return
    }

    const isMobile = window.innerWidth < 992
    const isDesktop = !isMobile
    const transition = isMobile ? new TransitionMobile() : new TransitionDesktop()
    const hashID = window.location.hash
    let activeIndex = 0;

    // Check for existing hash in url to scroll to last active slide
    if(hashID) {
      activeIndex = parseInt(hashID.replace('#', ''))
      setTimeout(()=> {
        transition.setPanelIndex(activeIndex)
      }, 1500) // safe delay to wait for element in dom instead of polling till it exists.
    }

    // Listen for nav clicks (deskstop and mobile)
    $('.course-content__nav li').each((ind, el) => {
      $(el).on('click', () => {
        history.pushState(null, null, '#'+ind)
        transition.setPanelIndex(ind)
      })
    })

    if(isDesktop) {
      // Window size changes
      $(window).on('resize', () => {
        transition.updateLayout()
        transition.updateHeight()
      })

      // Set starting panel
      transition.setPanelIndex(0) // Add logic later if we need to init at another index
    }

    if(isMobile) {
      // Listen for back clicks
      $('.mobile-container__back').on('click', (e) => {
        e.preventDefault();
        transition.backToNav();
      })
    }

    // Accordions throw a spanner when they change their height, we need to update
    // the panel heights. Luckily we don't need to support IE so we can use the
    // ResizeObserver. We listen to the panels we know have accordions in them
    // and call updateHeight() on our transition class instance.
    let firstLoad = true
    const resizeObserver = new ResizeObserver(entries => {
      if(firstLoad) {
        firstLoad = false
      } else {
        transition.updateHeight(true)
      }
    });

    resizeObserver.observe($('.entrytype-course-v2 .course-details').get(0))
    resizeObserver.observe($('.entrytype-course-v2 .course-begin').get(0))
    resizeObserver.observe($('.entrytype-course-v2 .course-career').get(0))

    $('[data-course-v2-content-trigger]').on('click', function(e) {
      e.preventDefault()
      const target = $(this).attr('data-course-v2-content-trigger')
      const $targetPanel = $(`[data-course-panel="${target}"]`)
      const $panels = $('[data-course-panel]')

      $(this).closest('.modal').modal('hide')

      if($targetPanel.length < 1) {
        return
      }

      let panelIndex = 0
      $panels.each(function(i) {
        if($(this).attr('data-course-panel') == target) {
          panelIndex = i
          return false
        }
      })

      history.pushState(null, null, '#'+panelIndex)
      transition.setPanelIndex(panelIndex, false)

      setTimeout(function() {
        const scrollTop = isMobile ? $('.entrytype-course-v2 .course-content__panels-mobile').offset().top - 100 : $('.entrytype-course-v2 .course-content__panels').offset().top - 100
        window.scrollTo({top: scrollTop, behavior: 'smooth'})
      }, 250)

    })
  })
})()
